import React from "react";
import { Card } from "@/components/ui/card";
import { Slider } from "@/components/ui/slider";
import { Label } from "@/components/ui/label";
import { Clock } from "lucide-react";
import { translations } from "@/lib/translations";

interface CookingTimePreferencesProps {
  onTimeChange?: (time: number) => void;
  initialTime?: number;
}

const CookingTimePreferences = ({
  onTimeChange = () => {},
  initialTime = 45,
}: CookingTimePreferencesProps) => {
  const [cookingTime, setCookingTime] = React.useState(initialTime);

  const handleTimeChange = (value: number[]) => {
    const newTime = value[0];
    setCookingTime(newTime);
    onTimeChange(newTime);
  };

  return (
    <Card className="w-full p-6 bg-white">
      <div className="space-y-6">
        <div className="flex items-center gap-2">
          <Clock className="w-6 h-6 text-primary" />
          <h2 className="text-2xl font-semibold">
            {translations.mealPlanner.cookingTime.title}
          </h2>
        </div>

        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <Label htmlFor="cooking-time">
              {translations.mealPlanner.cookingTime.maxTime}
            </Label>
            <span className="text-sm font-medium">
              {cookingTime} {translations.common.minutes}
            </span>
          </div>

          <Slider
            id="cooking-time"
            min={15}
            max={120}
            step={5}
            value={[cookingTime]}
            onValueChange={handleTimeChange}
            className="w-full"
          />

          <div className="flex justify-between text-sm text-muted-foreground">
            <span>15 {translations.common.minutes}</span>
            <span>120 {translations.common.minutes}</span>
          </div>

          <p className="text-sm text-muted-foreground mt-4">
            {translations.mealPlanner.cookingTime.description}
          </p>
        </div>
      </div>
    </Card>
  );
};

export default CookingTimePreferences;
